module.exports = __webpack_public_path__ + "static/media/24.7a64e72a.jpg";